import type { ApiEventId } from 'api/types/ApiTypedId';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

type ApiResponse = {
  ownRsvp: null | {
    answer: string;
    updated: string;
  };
};

function mapResponse(response: ApiResponse) {
  return response.ownRsvp;
}

const endpoint = new FetchEndpoint({
  urlFactory: (eventId: ApiEventId) => `/data/website/events/${eventId}/rsvp`,
  mapResponse,
});

// Exports

export const listingApiFetchOwnRsvp = endpoint.createFetchFn();
